import templateUrl from "./user-profile-detail.component.html";

const PROFILE_IMG_SIZE_LIMIT_MB = 5;

export const UserProfileDetailComponent = {
    templateUrl,
    bindings: {
        /** The user profile being displayed */
        userProfile: "<",
        /* The profile image for the user */
        profileImage: "<",
        /** Indicates whether it is possible to change the profile image or email for this profile */
        canEdit: "<",
        /** Action to be invoked when clicking on link to change profile image */
        changeProfileImage: "&onChangeProfileImage",
        /** Action to be invoked when clicking on link to change email address */
        changeEmailAddress: "&onChangeEmailAddress"
    },
    controller: class {
        constructor(fileService, apexApiUrl) {
            'ngInject';
            this.apexApiUrl = apexApiUrl;
            this.fileService = fileService;
        }

        $onChanges() {

        }
        onProfileImageFileSelected(profileImageFiles) {
            if (!profileImageFiles) {
                return;
            }
            const file = profileImageFiles;

            if (!this.fileService.isValidImage(file)) {
                alert('Please upload a valid image file')
                return;
            }

            if (this.fileService.getFileSizeInMB(file) > PROFILE_IMG_SIZE_LIMIT_MB) {
                alert('Please upload a picture smaller than ' + PROFILE_IMG_SIZE_LIMIT_MB + ' MB')
                return;
            }

            this.fileService.fileToDataUrl(file)
                .then(dataUrl => {
                    this.changeProfileImage({
                        $event: {
                            dataUrl: dataUrl,
                            fileName: file.name,
                            fileType: file.type
                        }
                    });
                });
        }

        onEditEmailAddress() {
            this.emailAddress = this.userProfile.EmailAddress;
            this.isEditingEmail = true;
        }

        onChangeEmailAddress() {
            console.log("changing")
            this.changeEmailAddress({
                $event: {
                    employeeID: this.userProfile.Id,
                    emailAddress: this.emailAddress
                }
            });
        }
    }
}
